module.exports = __webpack_public_path__ + "static/img/yifa_seal.8b346f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/me/salesOrder/imgs/yifa_seal.png
// module id = Medu
// module chunks = 2